// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"e026555d","692":"a9887e55","713":"b92ee382","796":"264ed40e"}[chunkId] + ".css";
};